/**
 * @generated SignedSource<<25a0cd483c2bbe1010543b62f6477561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentTestAccountBanner_pixQrCode$data = {
  readonly id: string;
  readonly isFromTestAccount: boolean | null | undefined;
  readonly " $fragmentType": "PaymentTestAccountBanner_pixQrCode";
};
export type PaymentTestAccountBanner_pixQrCode$key = {
  readonly " $data"?: PaymentTestAccountBanner_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentTestAccountBanner_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentTestAccountBanner_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromTestAccount",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "2d7b84619387d6a081410894a9c9be9b";

export default node;
